(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["combo"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var instances = new Map();

  function initCombo(root) {
    if (!root || root.dataset.comboInitialized === 'true') return;
    root.dataset.comboInitialized = 'true';

    var sectionId = root.getAttribute('data-section-id');

    // Quantity stepper
    var qtyWrap = root.querySelector('[data-quantity]');
    if (qtyWrap) {
      var qtyValueEl = qtyWrap.querySelector('[data-qty-value]');
      var decreaseBtn = qtyWrap.querySelector('[data-qty-decrease]');
      var increaseBtn = qtyWrap.querySelector('[data-qty-increase]');
      var qty = parseInt(qtyValueEl.textContent, 10) || 1;

      var onDecrease = function () {
        qty = Math.max(1, qty - 1);
        qtyValueEl.textContent = qty;
      };
      var onIncrease = function () {
        qty = qty + 1;
        qtyValueEl.textContent = qty;
      };

      if (decreaseBtn) decreaseBtn.addEventListener('click', onDecrease);
      if (increaseBtn) increaseBtn.addEventListener('click', onIncrease);
    }

    // Purchase option selection
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    options.forEach(function (option) {
      var radio = option.querySelector('[data-option-radio]');
      if (!radio) return;

      radio.addEventListener('change', function () {
        options.forEach(function (opt) {
          opt.classList.toggle('is-selected', opt === option);
        });
      });
    });

    // Accordion
    var accordion = root.querySelector('[data-accordion]');
    if (accordion) {
      var toggle = accordion.querySelector('[data-accordion-toggle]');
      var panel = accordion.querySelector('[data-accordion-panel]');

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var isOpen = accordion.classList.toggle('is-open');
          panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
        });
      }
    }

    instances.set(sectionId, { destroy: function () {} });
  }

  function initAll(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll('.v-combo[data-section-id]');
    sections.forEach(function (section) {
      initCombo(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-combo[data-section-id]');
    if (!sectionEl) return;
    initCombo(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFaq(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;
    root.dataset.faqInitialized = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

    function setPanelHeight(item, open) {
      var panel = item.querySelector('[data-faq-panel]');
      if (!panel) return;
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      if (!toggle) return;

      // Set initial height for whichever item(s) start open
      if (item.classList.contains('is-open')) {
        setPanelHeight(item, true);
      }

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all other items (single-open accordion)
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            other.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
            setPanelHeight(other, false);
          }
        });

        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
        setPanelHeight(item, !isOpen);
      });
    });

    // Keep open panel height correct on resize (text reflow changes scrollHeight)
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) setPanelHeight(item, true);
      });
    });
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.v-faq[data-section-id]').forEach(function (section) {
      initFaq(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-faq[data-section-id]');
    if (sectionEl) initFaq(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridsingle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SWIPE_THRESHOLD = 60;
    var instances = new Map();

    function initModulesSection(root) {
      if (!root) return;

      var sectionId = root.getAttribute('data-section-id');
      var swipeEnabled = root.getAttribute('data-swipe-enabled') === 'true';
      var stack = root.querySelector('[data-modules-stack]');
      if (!stack) return;

      var track = stack.querySelector('[data-stack-track]');
      var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-module-card]'));
      var prevBtn = stack.querySelector('[data-stack-prev]');
      var nextBtn = stack.querySelector('[data-stack-next]');
      var dots = Array.prototype.slice.call(stack.querySelectorAll('[data-stack-dot]'));

      if (!cards.length) return;

      var current = 0;
      var isDragging = false;
      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var pointerId = null;

      function render() {
        cards.forEach(function (card, i) {
          var diff = i - current;

          if (diff < 0) {
            card.setAttribute('data-pos', 'prev');
            card.style.removeProperty('--diff');
          } else {
            card.setAttribute('data-pos', diff === 0 ? 'active' : 'queued');
            card.style.setProperty('--diff', diff);
          }
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });

        if (prevBtn) {
          prevBtn.classList.toggle('is-disabled', current === 0);
          prevBtn.disabled = current === 0;
        }
        if (nextBtn) {
          nextBtn.classList.toggle('is-disabled', current === cards.length - 1);
          nextBtn.disabled = current === cards.length - 1;
        }
      }

      function goTo(index) {
        if (index < 0 || index > cards.length - 1) return;
        current = index;
        render();
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);

      if (dots.length) {
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            goTo(i);
          });
        });
      }

      function getActiveCard() {
        return cards[current];
      }

      function onPointerDown(e) {
        if (!swipeEnabled) return;
        var card = getActiveCard();
        if (!card || e.target.closest('[data-stack-prev], [data-stack-next], [data-stack-dot]')) return;

        isDragging = true;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        deltaX = 0;
        card.classList.add('is-dragging');
        if (card.setPointerCapture && pointerId != null) {
          try {
            card.setPointerCapture(pointerId);
          } catch (err) {}
        }
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        var card = getActiveCard();
        if (!card) return;

        deltaX = e.clientX - startX;
        var deltaY = e.clientY - startY;

        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaX) < 15) return;

        var rotate = deltaX / 20;
        card.style.transform = 'translate(' + deltaX + 'px, 0) rotate(' + rotate + 'deg)';
      }

      function onPointerUp() {
        if (!isDragging) return;
        isDragging = false;

        var card = getActiveCard();
        if (card) {
          card.classList.remove('is-dragging');
          card.style.transform = '';
        }

        if (deltaX <= -SWIPE_THRESHOLD) {
          next();
        } else if (deltaX >= SWIPE_THRESHOLD) {
          prev();
        }
        deltaX = 0;
      }

      if (track) {
        track.addEventListener('pointerdown', onPointerDown);
        track.addEventListener('pointermove', onPointerMove);
        track.addEventListener('pointerup', onPointerUp);
        track.addEventListener('pointercancel', onPointerUp);
        track.addEventListener('pointerleave', function (e) {
          if (isDragging && e.buttons === 0) onPointerUp();
        });
      }

      render();

      instances.set(sectionId, {
        destroy: function () {
          if (nextBtn) nextBtn.removeEventListener('click', next);
          if (prevBtn) prevBtn.removeEventListener('click', prev);
          if (track) {
            track.removeEventListener('pointerdown', onPointerDown);
            track.removeEventListener('pointermove', onPointerMove);
            track.removeEventListener('pointerup', onPointerUp);
            track.removeEventListener('pointercancel', onPointerUp);
          }
        },
      });
    }

    function initAll(context) {
      var scope = context || document;
      var sections = scope.querySelectorAll('.v-modules[data-section-id]');
      sections.forEach(function (section) {
        initModulesSection(section);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      var sectionEl = event.target.querySelector('.v-modules[data-section-id]');
      if (!sectionEl) return;

      var sectionId = sectionEl.getAttribute('data-section-id');
      var existing = instances.get(sectionId);
      if (existing) existing.destroy();

      initModulesSection(sectionEl);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var sectionEl = event.target.querySelector('.v-modules[data-section-id]');
      if (!sectionEl) return;
      var sectionId = sectionEl.getAttribute('data-section-id');
      var existing = instances.get(sectionId);
      if (existing) {
        existing.destroy();
        instances.delete(sectionId);
      }
    });

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initAll(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdf"] && !Shopify.designMode) return;
  try {
    
(function () {
  function absoluteUrl(url) {
    try {
      return new URL(url, window.location.href).href;
    } catch (e) {
      return url;
    }
  }

  function sameOrigin(url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function printViaWindow(url) {
    var win = window.open(url, '_blank');
    if (!win) {
      window.location.href = url;
      return;
    }
    var tryPrint = function () {
      try {
        win.focus();
        win.print();
      } catch (e) {
        /* viewer print button remains available */
      }
    };
    win.addEventListener('load', tryPrint);
    setTimeout(tryPrint, 1200);
  }

  function printPdf(url) {
    var absolute = absoluteUrl(url);

    if (!sameOrigin(absolute)) {
      printViaWindow(absolute);
      return;
    }

    var frame = document.createElement('iframe');
    frame.className = 'hdocs__print-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.src = absolute;

    frame.onload = function () {
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (e) {
        printViaWindow(absolute);
      }
      setTimeout(function () {
        if (frame.parentNode) frame.parentNode.removeChild(frame);
      }, 60000);
    };

    frame.onerror = function () {
      if (frame.parentNode) frame.parentNode.removeChild(frame);
      printViaWindow(absolute);
    };

    document.body.appendChild(frame);
  }

  function forceDownload(link) {
    var url = link.getAttribute('href');
    var name = link.getAttribute('data-file-name') || 'document.pdf';

    if (!url || typeof window.fetch !== 'function') return false;

    link.setAttribute('aria-busy', 'true');

    fetch(url, { mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var temp = document.createElement('a');
        temp.href = objectUrl;
        temp.download = name;
        document.body.appendChild(temp);
        temp.click();
        document.body.removeChild(temp);
        setTimeout(function () {
          URL.revokeObjectURL(objectUrl);
        }, 4000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      })
      .finally(function () {
        link.removeAttribute('aria-busy');
      });

    return true;
  }

  function initSection(root) {
    if (!root || root.dataset.hdocsInit === 'true') return;
    root.dataset.hdocsInit = 'true';

    root.addEventListener('click', function (event) {
      var printBtn = event.target.closest('[data-hdocs-print]');
      if (printBtn) {
        event.preventDefault();
        var pdf = printBtn.getAttribute('data-pdf');
        if (pdf) printPdf(pdf);
        return;
      }

      var downloadLink = event.target.closest('[data-hdocs-download]');
      if (downloadLink) {
        if (forceDownload(downloadLink)) {
          event.preventDefault();
        }
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hdocs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-track"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initTracker(root) {
    if (!root || root.dataset.trackerInitialized === 'true') return;
    root.dataset.trackerInitialized = 'true';

    var calculateBtn = root.querySelector('[data-tracker-calculate]');
    var printBtn = root.querySelector('[data-tracker-print]');
    var downloadBtn = root.querySelector('[data-tracker-download]');
    var note = root.querySelector('[data-tracker-note]');
    var weightRow = root.querySelector('[data-weight-row="true"]');
    var resultInputs = Array.prototype.slice.call(root.querySelectorAll('[data-result-input]'));

    if (!calculateBtn) return;

    calculateBtn.addEventListener('click', function () {
      if (!weightRow) {
        alert('Add a metric row marked as the weight row to calculate % body weight lost.');
        return;
      }

      var weightInputs = Array.prototype.slice.call(weightRow.querySelectorAll('[data-metric-input]'));

      var baselineInput = weightInputs.filter(function (input) {
        return input.getAttribute('data-column-index') === '0';
      })[0];

      var baseline = baselineInput ? parseFloat(baselineInput.value) : NaN;

      if (!baseline || isNaN(baseline)) {
        alert('Please enter a baseline weight before calculating.');
        return;
      }

      // Build a lookup of column label -> weight value (skip baseline itself)
      var weightByColumnLabel = {};
      weightInputs.forEach(function (input) {
        if (input.getAttribute('data-column-index') === '0') return;
        var label = (input.getAttribute('data-column-label') || '').trim().toLowerCase();
        var value = parseFloat(input.value);
        if (label && !isNaN(value)) {
          weightByColumnLabel[label] = value;
        }
      });

      var anyCalculated = false;

      resultInputs.forEach(function (input) {
        var label = (input.getAttribute('data-result-label') || '').trim().toLowerCase();
        if (Object.prototype.hasOwnProperty.call(weightByColumnLabel, label)) {
          var weightAtWeek = weightByColumnLabel[label];
          var percentLost = ((baseline - weightAtWeek) / baseline) * 100;
          input.value = percentLost.toFixed(1) + '%';
          anyCalculated = true;
        }
        // If no matching column, leave whatever the user already typed manually.
      });

      if (printBtn) printBtn.hidden = false;
      if (downloadBtn) downloadBtn.hidden = false;
      if (note) {
        note.hidden = false;
        note.textContent = anyCalculated
          ? note.textContent
          : note.textContent; // keep configured text either way
      }
    });

    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }

    function loadHtml2Pdf(callback) {
      if (window.html2pdf) {
        callback();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
      script.onload = callback;
      script.onerror = function () {
        alert('Could not load the PDF generator right now. Please try again, or use Print instead.');
      };
      document.head.appendChild(script);
    }

    if (downloadBtn) {
      downloadBtn.addEventListener('click', function () {
        var originalText = downloadBtn.textContent;
        downloadBtn.disabled = true;
        downloadBtn.textContent = 'Preparing PDF…';

        loadHtml2Pdf(function () {
          var panel = root.querySelector('.v-tracker__panel');
          var clone = panel.cloneNode(true);

          // Strip interactive controls that shouldn't appear in the PDF
          var stripSelectors = ['[data-tracker-actions]', '.v-tracker__calculate-row'];
          stripSelectors.forEach(function (sel) {
            var el = clone.querySelector(sel);
            if (el) el.remove();
          });

          // Swap every input for plain text so the typed values actually
          // render in the PDF snapshot (canvas capture doesn't read live
          // input values reliably)
          clone.querySelectorAll('input').forEach(function (input) {
            var span = document.createElement('span');
            span.className = 'v-tracker-pdf-value';
            span.textContent = input.value ? input.value : '—';
            input.replaceWith(span);
          });

          var wrapper = document.createElement('div');
          wrapper.style.position = 'fixed';
          wrapper.style.left = '-9999px';
          wrapper.style.top = '0';
          wrapper.style.width = '900px';
          wrapper.style.background = '#ffffff';
          wrapper.appendChild(clone);
          document.body.appendChild(wrapper);

          window.html2pdf()
            .set({
              margin: 10,
              filename: 'patient-progress-tracking.pdf',
              html2canvas: { scale: 2, backgroundColor: '#ffffff' },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(clone)
            .save()
            .then(function () {
              document.body.removeChild(wrapper);
              downloadBtn.disabled = false;
              downloadBtn.textContent = originalText;
            })
            .catch(function () {
              document.body.removeChild(wrapper);
              downloadBtn.disabled = false;
              downloadBtn.textContent = originalText;
              alert('Something went wrong generating the PDF. Please try again.');
            });
        });
      });
    }
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.v-tracker[data-section-id]').forEach(function (section) {
      initTracker(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-tracker[data-section-id]');
    if (sectionEl) initTracker(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["provider-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function clearHighlights(scope) {
    var marks = Array.prototype.slice.call(scope.querySelectorAll('mark[data-v-khero-mark]'));
    marks.forEach(function (mark) {
      var parent = mark.parentNode;
      if (!parent) return;
      parent.replaceChild(document.createTextNode(mark.textContent), mark);
      parent.normalize();
    });
  }

  function highlightText(scope, query) {
    var regex = new RegExp('(' + escapeRegExp(query) + ')', 'gi');

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var tag = node.parentNode && node.parentNode.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'MARK' || tag === 'INPUT' || tag === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        if (node.parentNode && node.parentNode.closest('[data-khero-search-form]')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNodes = [];
    var current;
    while ((current = walker.nextNode())) {
      textNodes.push(current);
    }

    var matchCount = 0;
    var firstMark = null;

    textNodes.forEach(function (node) {
      regex.lastIndex = 0;
      if (!regex.test(node.nodeValue)) return;
      regex.lastIndex = 0;

      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;

      while ((match = regex.exec(node.nodeValue))) {
        matchCount++;
        frag.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex, match.index)));

        var mark = document.createElement('mark');
        mark.setAttribute('data-v-khero-mark', '');
        mark.className = 'v-khero-mark';
        mark.textContent = match[0];
        frag.appendChild(mark);

        if (!firstMark) firstMark = mark;

        lastIndex = match.index + match[0].length;
        if (match.index === regex.lastIndex) regex.lastIndex++;
      }

      frag.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex)));
      node.parentNode.replaceChild(frag, node);
    });

    return { count: matchCount, firstMark: firstMark };
  }

  function initKhero(root) {
    if (!root || root.dataset.kheroInitialized === 'true') return;
    root.dataset.kheroInitialized = 'true';

    var form = root.querySelector('[data-khero-search-form]');
    var input = root.querySelector('[data-khero-search-input]');
    var resultsEl = root.querySelector('[data-khero-results]');
    if (!form || !input) return;

    var scopeSelector = root.getAttribute('data-highlight-scope') || 'main';
    var scope = document.querySelector(scopeSelector) || document.body;

    // Inject the highlight color styling once, scoped to this section's variables
    var style = document.createElement('style');
    style.textContent =
      '.v-khero-mark {' +
      'background: var(--v-khero-mark-bg, #FDE047);' +
      'color: var(--v-khero-mark-text, #1A1A2E);' +
      'border-radius: 3px;' +
      'padding: 0 1px;' +
      '}';
    document.head.appendChild(style);

    function runSearch() {
      clearHighlights(scope);

      var query = input.value.trim();

      if (!query) {
        if (resultsEl) resultsEl.hidden = true;
        return;
      }

      var result = highlightText(scope, query);

      if (resultsEl) {
        resultsEl.hidden = false;
        resultsEl.textContent = result.count > 0
          ? result.count + (result.count === 1 ? ' match found' : ' matches found')
          : 'No matches found';
      }

      if (result.firstMark) {
        result.firstMark.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      runSearch();
    });

    // Clear highlights as soon as the field is emptied
    input.addEventListener('input', function () {
      if (input.value.trim() === '') {
        clearHighlights(scope);
        if (resultsEl) resultsEl.hidden = true;
      }
    });
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.v-khero[data-section-id]').forEach(function (section) {
      initKhero(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-khero[data-section-id]');
    if (sectionEl) initKhero(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initGuide(root) {
    if (!root || root.dataset.guideInitialized === 'true') return;
    root.dataset.guideInitialized = 'true';

    var tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-guide-tab-btn]'));
    var tabContents = Array.prototype.slice.call(root.querySelectorAll('[data-guide-tab-content]'));

    // Design 2 — FAQ accordions (independent open/close, not tied to tab switching)
    var cgFaqs = Array.prototype.slice.call(root.querySelectorAll('[data-cg-faq]'));
    cgFaqs.forEach(function (faq) {
      var toggle = faq.querySelector('[data-cg-faq-toggle]');
      var panel = faq.querySelector('[data-cg-faq-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = faq.classList.toggle('is-open');
        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
      });
    });

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-guide-tab-target');

        tabButtons.forEach(function (b) {
          var isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', String(isActive));
        });

        tabContents.forEach(function (content) {
          content.classList.toggle('is-hidden', content.id !== targetId);
        });
      });
    });
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.v-guide[data-section-id]').forEach(function (section) {
      initGuide(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-guide[data-section-id]');
    if (sectionEl) initGuide(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-glossary"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initGlossary(root) {
    if (!root || root.dataset.glossaryInitialized === 'true') return;
    root.dataset.glossaryInitialized = 'true';

    var searchInput = root.querySelector('[data-glossary-search]');
    var letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-glossary-letter]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-glossary-group]'));
    var emptyMessage = root.querySelector('[data-glossary-empty]');

    var activeLetter = 'all';

    function applyFilters() {
      var query = (searchInput ? searchInput.value : '').trim().toLowerCase();
      var anyVisibleAtAll = false;
      var lettersWithMatches = [];

      groups.forEach(function (group) {
        var groupLetter = group.getAttribute('data-glossary-group');
        var letterMatches = activeLetter === 'all' || groupLetter === activeLetter;
        var entries = Array.prototype.slice.call(group.querySelectorAll('[data-glossary-entry]'));
        var anyVisibleInGroup = false;

        entries.forEach(function (entry) {
          var searchText = entry.getAttribute('data-glossary-search-text') || '';
          var searchMatches = query === '' || searchText.indexOf(query) !== -1;
          var visible = letterMatches && searchMatches;

          entry.classList.toggle('is-hidden', !visible);
          if (visible) anyVisibleInGroup = true;
        });

        group.classList.toggle('is-hidden', !anyVisibleInGroup);
        if (anyVisibleInGroup) {
          anyVisibleAtAll = true;
          if (lettersWithMatches.indexOf(groupLetter) === -1) {
            lettersWithMatches.push(groupLetter);
          }
        }
      });

      if (emptyMessage) {
        emptyMessage.hidden = anyVisibleAtAll;
      }

      // While searching: highlight every letter tab that has a match.
      // Once the search is cleared: restore the normal single active-letter state.
      letterButtons.forEach(function (btn) {
        var letter = btn.getAttribute('data-glossary-letter');

        if (query === '') {
          btn.classList.toggle('is-active', letter === activeLetter);
        } else if (letter === 'all') {
          btn.classList.remove('is-active');
        } else {
          btn.classList.toggle('is-active', lettersWithMatches.indexOf(letter) !== -1);
        }
      });
    }

    letterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeLetter = btn.getAttribute('data-glossary-letter');
        letterButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('.v-glossary[data-section-id]').forEach(function (section) {
      initGlossary(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.v-glossary[data-section-id]');
    if (sectionEl) initGlossary(sectionEl);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
